import * as React from "react";

const User: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
                d="M11.9998 15C15.3135 15 17.9998 12.3137 17.9998 9C17.9998 5.68629 15.3135 3 11.9998 3C8.68605 3 5.99976 5.68629 5.99976 9C5.99976 12.3137 8.68605 15 11.9998 15Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeMiterlimit="10"
            />
            <path
                d="M2.90503 20.2491C3.82712 18.6531 5.15298 17.3278 6.74942 16.4064C8.34586 15.485 10.1567 15 11.9999 15C13.8432 15 15.654 15.4851 17.2504 16.4065C18.8468 17.3279 20.1726 18.6533 21.0947 20.2493"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default React.memo(User);
